import Auth from "@/store/api/user/Auth";

function initialState() {
    return {
        access_token: null,
        refresh_token: null,
        user_obj: {}
    };
}

function parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
        atob(base64)
            .split("")
            .map(function(c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
    );

    return JSON.parse(jsonPayload);
}

export default {
    state: initialState,
    getters: {
        isLoggedIn: state => {
            // jwt time is in second, js new Date takes Milliseconds
            const exp = new Date(state.user_obj.exp * 1000);
            const now = new Date();
            return !!state.token && exp > now;
        }
    },
    mutations: {
        setAccessToken(state, token) {
            state.access_token = token;
            state.user_obj = parseJwt(token);
        },
        setRefreshToken(state, token) {
            state.refresh_token = token;
        },
        clearStorage(state) {
            const initState = initialState();
            Object.keys(initState).forEach(key => (state[key] = initState[key]));
        }
    },
    actions: {
        logout({ commit }) {
            commit("clearStorage");
        },
        login({ commit }, { username, password }) {
            return Auth.login(username, password).then(response => {
                commit("setAccessToken", response.data.accessToken);
                commit("setRefreshToken", response.data.refreshToken);
            });
        },
        LoginFromPasswordReset({ dispatch }, token) {
            dispatch("setUserDataWithToken", token);
        },
        setUserDataWithToken({ commit }, token) {
            commit("setAccessToken", token);
        },
        refreshToken({ commit }) {
            Auth.refreshToken().then(response => {
                commit("setAccessToken", response.data.accessToken);
            });
        },
        sendResetPasswordMail(context, email) {
            return Auth.sendResetPasswordMail(email);
        },
        resetPassword(context, { token, password }) {
            return Auth.setNewPassword(token, password);
        },
        changePassword(context, { password, oldpassword }) {
            return Auth.changePassword(password, oldpassword);
        }
    }
};
